import { getCurrentInstance } from "vue"

export function useRoute() {
    const instance = getCurrentInstance()

    if (!instance) {
        throw new Error("useRoute must be called within a setup function.")
    }

    const route = instance.proxy?.$route

    if (!route) {
        throw new Error("Route is undefined. Ensure Vue Router is properly installed.")
    }

    return route
}

export function useRouter() {
    const instance = getCurrentInstance()

    if (!instance) {
        throw new Error("useRouter must be called within a setup function.")
    }

    const router = instance.proxy?.$router

    if (!router) {
        throw new Error("Router is undefined. Ensure Vue Router is properly installed.")
    }

    return router
}
